import { render, staticRenderFns } from "./Refund-policy.vue?vue&type=template&id=1ca978ae"
import script from "./Refund-policy.vue?vue&type=script&lang=js"
export * from "./Refund-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports